const UrlSearch = 'shop-url'

export function getItem() {
  return JSON.parse(sessionStorage.getItem(UrlSearch));
}

export function setItem(UrlSearchtoken) {
  return sessionStorage.setItem(UrlSearch,UrlSearchtoken);
}

export function removeItem() {
    sessionStorage.removeItem(UrlSearch);
}

export function getKey(key){
    return JSON.parse(sessionStorage.getItem(key));
}
export function setKey(key, value){
    return sessionStorage.setItem(key, value);
}
export function removeKey(key){
    sessionStorage.removeItem(key);
}



// WEBPACK FOOTER //
// ./src/components/utils/sessionStorage.js